// extracted by mini-css-extract-plugin
export default {"list":"ip-holders-list_list__8O1il","buttons":"ip-holders-list_buttons__piGSH","pager":"ip-holders-list_pager__Mdvly"};